/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var promisePolyfill = require('promise-polyfill');

function polyfills() {
    if (!window.Promise) {
        window.Promise = promisePolyfill.default;
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
            value: function (predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return kValue.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return kValue;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return undefined.
                return undefined;
            },
            configurable: true,
            writable: true,
        });
    }

    //polyfill for string  includes
    if (!String.prototype.includes) {
        String.prototype.includes = function (str) {
            return this.indexOf(str) !== -1;
        };
    }

    //polyfill for array includes
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function (searchElement, fromIndex) {
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                // 1. Let O be ? ToObject(this value).
                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(searchElement, elementK) is true, return true.
                    if (sameValueZero(o[k], searchElement)) {
                        return true;
                    }
                    // c. Increase k by 1.
                    k++;
                }

                // 8. Return false
                return false;
            },
        });
    }
    //polyfill for array foreach

    if (!Array.prototype.forEach) {
        Array.prototype.forEach = function (callback /*, thisArg*/) {
            var T, k;

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be the result of calling toObject() passing the
            // |this| value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get() internal
            // method of O with the argument "length".
            // 3. Let len be toUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If isCallable(callback) is false, throw a TypeError exception.
            // See: http://es5.github.com/#x9.11
            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            // 5. If thisArg was supplied, let T be thisArg; else let
            // T be undefined.
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // 6. Let k be 0.
            k = 0;

            // 7. Repeat while k < len.
            while (k < len) {
                var kValue;

                // a. Let Pk be ToString(k).
                //    This is implicit for LHS operands of the in operator.
                // b. Let kPresent be the result of calling the HasProperty
                //    internal method of O with argument Pk.
                //    This step can be combined with c.
                // c. If kPresent is true, then
                if (k in O) {
                    // i. Let kValue be the result of calling the Get internal
                    // method of O with argument Pk.
                    kValue = O[k];

                    // ii. Call the Call internal method of callback with T as
                    // the this value and argument list containing kValue, k, and O.
                    callback.call(T, kValue, k, O);
                }
                // d. Increase k by 1.
                k++;
            }
            // 8. return undefined.
        };
    }

    // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    (function (arr) {
        arr.forEach(function (item) {
            if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
                return;
            }
            Object.defineProperty(item, 'remove', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function remove() {
                    if (this.parentNode !== null) this.parentNode.removeChild(this);
                },
            });
        });
    })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

    var rootElement = window.document.documentElement;
    var $rootElement = $(rootElement);

    addGlobalEventListener('change', markValue);
    addValueChangeByJsListener(markValue);

    $.prototype.checkAndTriggerAutoFillEvent = jqCheckAndTriggerAutoFillEvent;

    // Need to use blur and not change event as Chrome does not fire change events
    // in all cases an input is changed (e.g. when starting to type and then finish
    // the input by auto filling a username)
    addGlobalEventListener('blur', function (target) {
        // setTimeout needed for Chrome as it fills other form fields a little later...
        window.setTimeout(function () {
            findParentForm(target).find('input').checkAndTriggerAutoFillEvent();
        }, 20);
    });

    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (search, this_len) {
            if (this_len === undefined || this_len > this.length) {
                this_len = this.length;
            }
            return this.substring(this_len - search.length, this_len) === search;
        };
    }

    window.document.addEventListener(
        'DOMContentLoaded',
        function () {
            // mark all values that are present when the DOM is ready. We don't need to
            // trigger a change event here, as js libs start with those values already being
            // set!
            forEach(document.getElementsByTagName('input'), markValue);

            // The timeout is needed for Chrome as it auto fills login forms some time after
            // DOMContentLoaded!
            window.setTimeout(function () {
                $rootElement.find('input').checkAndTriggerAutoFillEvent();
            }, 200);
        },
        false
    );

    return;

    // ----------

    function jqCheckAndTriggerAutoFillEvent() {
        var i, el;
        for (i = 0; i < this.length; i++) {
            el = this[i];
            if (!valueMarked(el)) {
                markValue(el);
                triggerChangeEvent(el);
            }
        }
    }

    function valueMarked(el) {
        if (!('$$currentValue' in el)) {
            // First time we see an element we take it's value attribute as real value. This
            // might have been filled in the backend, ...
            // Note: it's important to not use the value property here!
            el.$$currentValue = el.getAttribute('value');
        }

        var val = el.value;
        var $$currentValue = el.$$currentValue;
        if (!val && !$$currentValue) {
            return true;
        }
        return val === $$currentValue;
    }

    function markValue(el) {
        el.$$currentValue = el.value;
    }

    function addValueChangeByJsListener(listener) {
        var jqProto = $.prototype;
        var _val = jqProto.val;
        jqProto.val = function (newValue) {
            var res = _val.apply(this, arguments);
            if (arguments.length > 0) {
                forEach(this, function (el) {
                    listener(el, newValue);
                });
            }
            return res;
        };
    }

    function addGlobalEventListener(eventName, listener) {
        // Use a capturing event listener so that we also get the event when it's
        // stopped! Also, the blur event does not bubble.
        rootElement.addEventListener(eventName, onEvent, true);

        function onEvent(event) {
            var target = event.target;
            listener(target);
        }
    }

    function findParentForm(el) {
        while (el) {
            if (el.nodeName === 'FORM') {
                return $(el);
            }
            el = el.parentNode;
        }
        return $();
    }

    function forEach(arr, listener) {
        if (arr.forEach) {
            return arr.forEach(listener);
        }
        var i;
        for (i = 0; i < arr.length; i++) {
            listener(arr[i]);
        }
    }

    function triggerChangeEvent(element) {
        var doc = window.document;
        var event = doc.createEvent('HTMLEvents');
        event.initEvent('change', true, true);
        element.dispatchEvent(event);
    }
}
module.exports = {
    polyfills: polyfills,
};
